import script from "./BlogSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogSection.vue?vue&type=script&setup=true&lang=js"

import "./BlogSection.vue?vue&type=style&index=0&id=ae35b6f2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae35b6f2"]])

export default __exports__